import React from "react";
import useUnits from "../useUnits";

const Unseen = () => {
  const { unseen } = useUnits();
  return <>{unseen?.toString()}</>;
};

export default Unseen;
